'use client';

import type { ProductDetailData } from '@eliadmin/core/src/api/products/types/product-types';

import { useVariantsStore } from '@eliadmin/core/src/stores/variant-store';
import { DesktopTable } from './variants/desktop-table';
import { MobileTable } from './variants/mobile-table';
import { cn } from '@eliadmin/core/src/utils/style-utils';

export function ProductVariantsContainer({ product }: { product: ProductDetailData }) {
  const variants = useVariantsStore(state => state.product.variants) || [];

  return (
    <div className={cn('custom-section')}>
      <div className={cn('custom-container')}>
        <DesktopTable variants={variants} product={product} />
        <MobileTable variants={variants} />
      </div>
    </div>
  );
}
